import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const c = t((r, e) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: e,
    ...r,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3512",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8.01 3c.83 0 1.5-.67 1.5-1.5S8.84 0 8.01 0s-1.5.67-1.5 1.5S7.18 3 8.01 3M15.25 16H.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h14.5c.41 0 .75.34.75.75s-.34.75-.75.75M8 7.5H.75C.34 7.5 0 7.16 0 6.75S.34 6 .75 6H8c.41 0 .75.34.75.75s-.34.75-.75.75"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8 16c-.41 0-.75-.34-.75-.75v-8.5c0-.41.34-.75.75-.75s.75.34.75.75v8.5c0 .41-.34.75-.75.75"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3512)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
c.displayName = "AgencyInfoIcon";
export {
  c as AgencyInfoIcon,
  c as default
};
//# sourceMappingURL=index.js.map
